import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Shield, Crosshair, Wrench } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function SafesAccessories() {
  useDocumentMeta('Gun Safes, Cases & Shooting Accessories | Kjergaard Sports', 'Find gun safes, cases, holsters, cleaning supplies, magazines, targets, and shooting accessories at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Safes', 'Cases', 'Holsters', 'Cleaning supplies', 'Magazines', 'Rests', 'Targets', 'Maintenance items', 'Shooting accessories'];
  return <div data-id="element-1125">
      <PageHero title="Gun Safes, Cases & Shooting Accessories" image="https://cdn.magicpatterns.com/uploads/esrRsJE1XbS5zcQi7PgR9E/safes-display.jpg" alt="Gun safes and secure storage at Kjergaard Sports" data-id="element-1126" />

      <section className="py-20 bg-brand-offwhite" data-id="element-1127">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1128">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-1129">
            <div data-id="element-1130">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1131">
                Secure Storage & Essential Gear
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-1132">
                Protecting your investment and maintaining your equipment is
                just as important as the firearm itself. Kjergaard Sports
                carries a robust selection of heavy-duty gun safes, secure
                transport cases, and everyday maintenance accessories.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-1133">
                Visit the store to compare options in person. We can help you
                evaluate safe sizes, fire ratings, and security features to find
                the right fit for your home.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-1134">
                <h3 className="font-serif text-xl mb-4" data-id="element-1135">
                  Our Accessory Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-1136">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-1137">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-1138" />
                      <span className="text-brand-charcoal/90" data-id="element-1139">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div data-id="element-1140">
              <img src="https://cdn.magicpatterns.com/uploads/jwChz1kho8pae8NFhrqrQH/accessories-wall.jpg" alt="Shooting accessories at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1141" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-1142">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-1143">
              <Shield className="w-10 h-10 text-brand-hunter mb-4" data-id="element-1144" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-1145">
                Secure Storage
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1146">
                Heavy-duty gun safes, lockboxes, and secure transport cases to
                keep your firearms protected at home and on the road.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-1147">
              <Crosshair className="w-10 h-10 text-brand-hunter mb-4" data-id="element-1148" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-1149">
                Shooting Accessories
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1150">
                Holsters, magazines, slings, rests, targets, and the practical
                gear you need for a successful day at the range or in the field.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-1151">
              <Wrench className="w-10 h-10 text-brand-hunter mb-4" data-id="element-1152" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-1153">
                Cleaning & Maintenance
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1154">
                Solvents, oils, brushes, rods, and complete cleaning kits to
                keep your equipment functioning reliably.
              </p>
            </div>
          </div>

          <div className="relative rounded-sm overflow-hidden shadow-lg" data-id="element-1155">
            <img src="https://cdn.magicpatterns.com/uploads/4W49omroAHfAdaTefJNmcK/targets-shooting-supplies.jpg" alt="Targets and shooting supplies at Kjergaard Sports" className="w-full h-[300px] object-cover" data-id="element-1156" />
            <div className="absolute inset-0 bg-brand-charcoal/60 flex items-center justify-center p-8" data-id="element-1157">
              <h3 className="text-3xl md:text-4xl font-serif text-brand-offwhite text-center max-w-2xl drop-shadow-md" data-id="element-1158">
                Everything You Need for the Range
              </h3>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-1159" />
    </div>;
}